import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../../../services/usuarios.service'

@Component({
  selector: 'app-registro-acciones',
  templateUrl: './registro-acciones.component.html',
  styleUrls: ['./registro-acciones.component.css']
})
export class RegistroAccionesComponent implements OnInit {

  constructor(private usuariosService: UsuariosService,
  ) 
  { }
  titulo= "Ultimas acciones"
  tamanoPagina = 10
  pagina = 1

  acciones:any=[]
  respuesta:any

  ngOnInit(): void {
    this.cargarAcciones()
  }
  cargarAcciones(){
    this.usuariosService.traerAcciones()
    .subscribe(resp => {
      this.respuesta = resp;
      this.acciones = this.respuesta.data
    })
  }
}
